<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm" :title="$t('Simulation')" route-back="SimulationIndex"/>
      </div>
      <div class=" page-subtitle mt-2">{{ $t('simulation.subtitle') }}</div>

      <steps-menu
        :current-step="currentStep"
        :last-active-step="lastActiveStep"
        :tab-menu="tabMenu"
        @stepChanged="stepChanged"/>

      <simulation-charge-fonciere
        v-if="currentStep === 0"
        ref="chargeFonciere"
        :simulation-id="simulationId"
        :urban-study-id="urbanStudyId"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <simulation-lots
        v-if="currentStep === 1"
        ref="lots"
        :simulation-id="simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueLots="didContinueLots"/>

      <simulation-constructions
        v-if="currentStep === 2"
        ref="constructions"
        :simulation-id="simulationId"
        :is-operation-linked="isOperationLinked"
        :operation-id="operationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueConstructions="didContinueConstructions"/>

      <simulation-honoraires
        v-if="currentStep === 3"
        ref="charges"
        :simulation-id="simulationId"
        :is-operation-linked="isOperationLinked"
        :operation-id="operationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueHonoraires="didContinueHonoraires"/>

      <simulation-insurances
        v-if="currentStep === 4"
        ref="insurances"
        :simulation-id="simulationId"
        :bank-credit="bankCredit"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinueInsurances="didContinueInsurances"/>

    </b-container>
  </div>

</template>

<script>

import StepsMenu from "../../components/b122/stepsMenu";
import i18n from '../../i18n'
import BackArrow from '../../components/b122/BackArrow'
import SimulationChargeFonciere from "./createEditSteps/SimulationChargeFonciere";
import SimulationLots from "./createEditSteps/SimulationLots";
import SimulationConstructions from "./createEditSteps/SimulationConstructions";
import SimulationHonoraires from "./createEditSteps/SimulationHonoraires";
import SimulationInsurances from "./createEditSteps/SimulationInsurances";
import api from "../../services/api";

export default {

  name: "SimulationCreateEdit",

  components: {
    SimulationInsurances,
    SimulationHonoraires,
    SimulationConstructions,
    SimulationLots,
    SimulationChargeFonciere,
    StepsMenu,
    i18n,
    BackArrow
  },

  data() {
    return {
      currentStep: 0,
      simulationId: this.$route.params.simulationId,
      urbanStudyId: this.$route.params.urbanStudyId,
      isOperationLinked: this.$route.params.isOperationLinked === 'true' || this.$route.params.isOperationLinked === true,
      operationId: this.$route.params.operationId,
      lotsCreationDone: false,
      constructionsCreationDone: false,
      honorairesCreationDone: false,
      insurancesCreationDone: false,
      bankCredit: {
        amount: 0,
        interest: 0,
        duration: 0
      },
      askConfirm: false
    }
  },

  computed: {
    tabMenu() {
      return [i18n.t('simulation.ChargeFonciere'), i18n.t('simulation.Lots'), i18n.t('simulation.Constructions'), i18n.t('simulation.Honoraires'), i18n.t('simulation.Insurances')]
    },

    lastActiveStep() {
      if (this.insurancesCreationDone) {
        return 4
      } else if (this.honorairesCreationDone) {
        return 3
      } else if (this.constructionsCreationDone) {
        return 2
      } else if (this.lotsCreationDone) {
        return 1
      } else {
        return 0
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    fetchData() {
      if (this.simulationId) {
        this.fetchSimulation()
      }
    },

    fetchSimulation() {
      api
        .get(`/simulation/${this.simulationId}`)
        .then(response => {
          this.lotsCreationDone = response.data.lotsCreationDone
          this.constructionsCreationDone = response.data.constructionsCreationDone
          this.honorairesCreationDone = response.data.honorairesCreationDone
          this.insurancesCreationDone = response.data.insurancesCreationDone
          this.bankCredit = response.data.bankCredit
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    stepChanged(index) {
      this.currentStep = index
    },

    didBack() {
      this.currentStep--
      this.$nextTick(() => {
        this.successToast()
      })
    },

    incrementStep() {
      this.currentStep++
      this.$nextTick(() => {
        this.successToast()
      })
    },

    async didChangeValue() {
      this.askConfirm = true
    },

    async didContinue(simulationId) {
      this.simulationId = simulationId
      this.incrementStep()
    },

    async didContinueLots() {
      this.lotsCreationDone = true
      this.incrementStep()
    },

    async didContinueConstructions() {
      this.constructionsCreationDone = true
      this.incrementStep()
    },

    async didContinueHonoraires() {
      this.honorairesCreationDone = true
      this.incrementStep()
    },

    async didContinueInsurances() {
      this.$router.push({
        name: 'SimulationShow',
        params: {
          simulationId: this.simulationId
        }
      }, () => {
        this.$nextTick(() => {
          this.successToast()
        })
      })
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Simulation') + ' ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/SimulationCreateEdit.vue